/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useEffect } from 'react';
import { useMutation } from 'react-apollo';

import { markErrorAsHandled } from '@confluence/graphql';
import { isUnauthorizedError } from '@confluence/error-boundary';

import type { useCreateInvitationUrlCreateInvitationMutation as useCreateInvitationUrlCreateInvitationMutation$data } from './__types__/useCreateInvitationUrlCreateInvitationMutation';

export const useCreateInvitationUrl = () => {
	const [createNewInviteLink, { data, loading, error, called }] =
		useMutation<useCreateInvitationUrlCreateInvitationMutation$data>(gql`
			mutation useCreateInvitationUrlCreateInvitationMutation {
				createInvitationUrl {
					id
					url
				}
			}
		`);

	useEffect(() => {
		if (error) {
			if (isUnauthorizedError(error)) {
				markErrorAsHandled(error);
			}
		}
	}, [error]);

	const newInviteLink = data?.createInvitationUrl?.url;

	return {
		createNewInviteLink,
		newInviteLink,
		called,
		loading,
		error,
	};
};
